import { render, staticRenderFns } from "./ManageReasons.vue?vue&type=template&id=3fc6e8bb&scoped=true"
import script from "./ManageReasons.vue?vue&type=script&lang=js"
export * from "./ManageReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6e8bb",
  null
  
)

export default component.exports